// 二级域名通配符解析
// 配置里把二级域名写成 * ，每次解析都会替换成一段新的 32 位随机字符串
// 例：https://*.a.com  ->  https://k3f9x2m8q1w7e4r6t5y0u9i8o7p6a5s.a.com

const CHARS = 'abcdefghijklmnopqrstuvwxyz0123456789'

// 生成 length 位随机字符串，只用 DNS 域名合法字符（小写字母 + 数字）
function randomLabel(length = 32) {
  const bytes = new Uint8Array(length)
  const crypto = window.crypto || window.msCrypto
  if (crypto && crypto.getRandomValues) {
    crypto.getRandomValues(bytes)
  } else {
    for (let i = 0; i < length; i++) {
      bytes[i] = Math.floor(Math.random() * 256)
    }
  }
  let label = ''
  for (let i = 0; i < length; i++) {
    label += CHARS[bytes[i] % CHARS.length]
  }
  return label
}

// 把 URL 主机名里的 * 替换成随机字符串，只处理主机名部分，
// 路径和查询参数里的 * 原样保留。URL 里没有 * 时原样返回。
export function resolveWildcardUrl(url) {
  if (!url || url.indexOf('*') === -1) {
    return url
  }
  return url.replace(
    /^([a-zA-Z][a-zA-Z\d+.-]*:\/\/)([^/?#]*)/,
    (match, scheme, host) => scheme + host.replace(/\*/g, () => randomLabel())
  )
}

export default resolveWildcardUrl
